import { render, staticRenderFns } from "./NewAnnouncementModal.vue?vue&type=template&id=46cf6af7&scoped=true"
import script from "./NewAnnouncementModal.vue?vue&type=script&lang=js"
export * from "./NewAnnouncementModal.vue?vue&type=script&lang=js"
import style0 from "./NewAnnouncementModal.vue?vue&type=style&index=0&id=46cf6af7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cf6af7",
  null
  
)

export default component.exports